export default __webpack_public_path__ + "4ae6b93763081923ab5286019324fbfd.png";